module.exports = __webpack_public_path__ + "static/media/YM75_1.aa17c02c.jpg";